/**
 * TanStack Query hooks for `invoice-crud-permission-scope`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invoiceCrudPermissionScopeQueryKeys,
	type CreateInvoiceCrudPermissionScopeBody,
	type ListInvoiceCrudPermissionScopeResponse,
	type InvoiceCrudPermissionScopeRow,
} from "./api";

export function useInvoiceCrudPermissionScopeList(): UseQueryResult<ListInvoiceCrudPermissionScopeResponse, Error> {
	return useQuery({
		queryKey: invoiceCrudPermissionScopeQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvoiceCrudPermissionScopeCreate(): UseMutationResult<InvoiceCrudPermissionScopeRow, Error, CreateInvoiceCrudPermissionScopeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceCrudPermissionScopeQueryKeys.all });
		},
	});
}

export function useInvoiceCrudPermissionScopeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceCrudPermissionScopeQueryKeys.all });
		},
	});
}
